import { BrowserRouter, Route, Switch } from "react-router-dom";

import "./App.less";
// import Graph from "./components/Graph/Graph";
import { getUserFromStorage } from "./services/userService";
import React, { Suspense, useEffect, useMemo, useState } from "react";
import UserContext from "./contexts/UserContext";
import NavContext from "./contexts/NavContext";
import ThemeContext from "./contexts/ThemeContext";
import ReactLoading from "react-loading";
import GuardedAdminRoute from "./components/GuardedAdminRoute/GuardAdminRoute";
import GuardedRoute from "./components/GuardRoute/GuardRoute";
const CallCenterScreen = React.lazy(() =>
    import("./screens/CallCenterScreen/CallCenterScreen")
);
const ChangePasswordScreen = React.lazy(() =>
    import("./screens/CallCenterChangePasswordScreen/CallCenterChangePasswordScreen")
);

function Routing() {
    return (
        <div>
            <Suspense
                fallback={
                    <div className="fixed top-1/2 w-full flex items-center justify-center">
                        <ReactLoading type="cylon" color="black" />
                    </div>
                }
            >
                <GuardedRoute
                    exact
                    path="/call-center"
                    component={CallCenterScreen}
                    roles={["CALL_CENTER_AGENT"]}
                />


                <GuardedRoute
                    exact
                    path="/call-center/change_password"
                    roles={["CALL_CENTER_AGENT"]}
                    component={ChangePasswordScreen}
                />
            </Suspense>
        </div>
    );
}

export default Routing;
